import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const ranked = [...comics].sort((a, b) => a.rank - b.rank).slice(0, 10);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            <i className="ri-trophy-line text-amber-400 mr-2"></i>
            排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">人气漫画排行榜，每周更新</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
        >
          查看完整榜单 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="bg-background-100 rounded-xl overflow-hidden">
        {ranked.map((comic, index) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="flex items-center gap-4 px-4 py-3 hover:bg-background-200/70 transition-colors border-b border-background-200/70 last:border-0 cursor-pointer"
          >
            <span
              className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-300 text-foreground-600'
              }`}
            >
              {index + 1}
            </span>
            <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-semibold text-foreground-950 truncate">{comic.title}</h4>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700">{comic.tags[0]}</span>
                {comic.status === '连载中' && (
                  <span className="text-xs text-secondary-600 flex items-center gap-0.5">
                    <i className="ri-circle-fill text-[6px]"></i>连载中
                  </span>
                )}
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="flex items-center gap-1 justify-end">
                <i className="ri-star-fill text-xs text-amber-400"></i>
                <span className="text-sm font-semibold text-foreground-700">{comic.rating}</span>
              </div>
              <p className="text-xs text-foreground-500 mt-0.5">
                {(comic.views / 10000).toFixed(0)}万阅读
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}